var m = require('mithril');
var prop = require('mithril/stream');
var pagination = {};

pagination.oninit = function (vnode) {
  var ctrl = this;
  ctrl.randomId = Math.random().toString(36).substring(7);
  var initialData = vnode.attrs.data || [];
  // Initialize itemsPerPage, originalData, data, and searchEquipmentValue
  ctrl.itemsPerPage = vnode.attrs.itemsPerPage || 10;
  ctrl.originalData = JSON.parse(JSON.stringify(initialData));
  ctrl.dataReference = initialData;
  ctrl.searchEquipmentValue = vnode.attrs.searchEquipmentValue ? vnode.attrs.searchEquipmentValue() : '';
  ctrl.smallScreen = false;
  ctrl.redrawPending = false;
    ctrl.updateSmallScreen = function (dom) {
      if (!dom) return;
      var isSmall = dom.clientWidth < 620;
      if (ctrl.smallScreen !== isSmall) {
        ctrl.smallScreen = isSmall;
        m.redraw();
      }
    };
  ctrl.scheduleRedraw = function () {
    if (ctrl.redrawPending) return;
    ctrl.redrawPending = true;
    setTimeout(function () {
      ctrl.redrawPending = false;
      m.redraw();
    }, 0);
  };
  // Function to initialize data and pagination
  ctrl.init = function (data) {
    ctrl.initData = JSON.parse(JSON.stringify(data));
    ctrl.data = data;
    ctrl.data.splice(1);
    ctrl.selectedPage = prop(1);

    ctrl.numberOfPages = prop(Math.ceil(ctrl.initData.length / ctrl.itemsPerPage));

    var newViewArray = ctrl.initData.slice(0, ctrl.itemsPerPage);
    ctrl.data.length = 0;
    ctrl.data.push(...newViewArray);
    if (vnode.attrs.reinitializePagination && vnode.attrs.reinitializePagination()) {
      vnode.attrs.reinitializePagination(false);
    }
    ctrl.scheduleRedraw();
    // Pagination functions
    ctrl.firstPage = function () {
      ctrl.selectedPage(1);
      ctrl.data.splice(0);
      ctrl.data.push(...ctrl.initData.slice((ctrl.selectedPage() - 1) * ctrl.itemsPerPage, ((ctrl.selectedPage() - 1) * ctrl.itemsPerPage + ctrl.itemsPerPage)));
    };

    ctrl.previusPage = function () {
      ctrl.selectedPage(ctrl.selectedPage() - 1);
      ctrl.data.splice(0);
      ctrl.data.push(...ctrl.initData.slice((ctrl.selectedPage() - 1) * ctrl.itemsPerPage, ((ctrl.selectedPage() - 1) * ctrl.itemsPerPage + ctrl.itemsPerPage)));
    };

    ctrl.nextPage = function () {
      ctrl.selectedPage(ctrl.selectedPage() + 1);
      ctrl.data.splice(0);
      ctrl.data.push(...ctrl.initData.slice((ctrl.selectedPage() - 1) * ctrl.itemsPerPage, ((ctrl.selectedPage() - 1) * ctrl.itemsPerPage + ctrl.itemsPerPage)));
    };

    ctrl.lastPage = function () {
      ctrl.selectedPage(ctrl.numberOfPages());
      ctrl.data.splice(0);
      ctrl.data.push(...ctrl.initData.slice((ctrl.selectedPage() - 1) * ctrl.itemsPerPage, ((ctrl.selectedPage() - 1) * ctrl.itemsPerPage + ctrl.itemsPerPage)));
    };

    ctrl.showPage = function (page) {
      ctrl.selectedPage(page);
      ctrl.data.splice(0);
      ctrl.data.push(...ctrl.initData.slice((ctrl.selectedPage() - 1) * ctrl.itemsPerPage, ((ctrl.selectedPage() - 1) * ctrl.itemsPerPage + ctrl.itemsPerPage)));
    };
  };
  
  ctrl.init(initialData);
};

pagination.onupdate = function (vnode) {
  var ctrl = this;
  if (vnode.attrs.data !== ctrl.dataReference) {
    ctrl.dataReference = vnode.attrs.data;
    ctrl.originalData = JSON.parse(JSON.stringify(vnode.attrs.data || []));
    ctrl.init(vnode.attrs.data || []);
    return;
  }

  if (vnode.attrs.searchEquipmentValue && vnode.attrs.searchEquipmentValue() != ctrl.searchEquipmentValue) {
    ctrl.searchEquipmentValue = vnode.attrs.searchEquipmentValue();
    let filteredData = ctrl.originalData.filter(function (item) {
      return (
        item.name.toLowerCase().includes(ctrl.searchEquipmentValue.toLowerCase()) ||
        item['@class'].toLowerCase().includes(ctrl.searchEquipmentValue.toLowerCase())
      );
    });

    vnode.attrs.data.splice(0);
    vnode.attrs.data.push(...filteredData);
    ctrl.init(vnode.attrs.data);
  }


  if (vnode.attrs.reinitializePagination && vnode.attrs.reinitializePagination()) {
    ctrl.originalData = JSON.parse(JSON.stringify(vnode.attrs.data || []));
    ctrl.dataReference = vnode.attrs.data;
    ctrl.init(vnode.attrs.data || []);
  }
  window.onresize = m.redraw;
};


pagination.view = function (vnode) {
  var ctrl = this;
  if (ctrl.numberOfPages() > 1) {
    return m('div.flex.flex-wrap', {
        id: 'pagination-container-'+ctrl.randomId,
        oncreate: function (vnode) {
          ctrl.updateSmallScreen(vnode.dom);
        },
        onupdate: function (vnode) {
          ctrl.updateSmallScreen(vnode.dom);
        },
      },[
      function () {
        if (ctrl.numberOfPages() > 1) {
          return m('a.f4.ba.bw1.ph3.pv2.tc.v-btm.dib.pointer.mb1', {
            onclick: function (e) {
              if (ctrl.selectedPage() != 1) {
                ctrl.firstPage();
              }
            },
          }, [
            m('span', {'aria-hidden': 'true'}, '«'),
          ]);
        }
      }(),
      m('a.f4.ba.bw1.ph3.pv2.tc.v-btm.dib.pointer.ml2.mb1', {
        onclick: function (e) {
          if (ctrl.selectedPage() != 1) {
            ctrl.previusPage();
          }
        }
      }, [
        m('span', {'aria-hidden': 'true'}, '<'),
      ]),
      function () {
        var tabs = [];
        var list = function (page) {
          return m('a.f4.ba.bw1.ph3.pv2.tc.v-btm.dib.pointer.ml2.mb1' + (ctrl.selectedPage() == page ? ' bg-mid-gray' : ''), {
            onclick: function (e) {
              ctrl.showPage(page);
            }
          }, [
            m('span', {'aria-hidden': 'true'}, page),
          ]);
        };
        if (!ctrl.smallScreen && ctrl.numberOfPages()<=7) {
          for (var i=0; i<ctrl.numberOfPages();i++) {
            tabs.push(list(i+1))
          }
          return tabs
        }else if (!ctrl.smallScreen) {
          if (ctrl.selectedPage()<4) {
            for (var i=0; i<7;i++) {
              tabs.push(list(i+1))
            } 
            return tabs
          }
          if (ctrl.selectedPage()>3 && (ctrl.numberOfPages()-2)>ctrl.selectedPage()) {
            tabs.push(list(ctrl.selectedPage()-3))
            tabs.push(list(ctrl.selectedPage()-2))
            tabs.push(list(ctrl.selectedPage()-1))
            tabs.push(list(ctrl.selectedPage()))
            tabs.push(list(ctrl.selectedPage()+1))
            tabs.push(list(ctrl.selectedPage()+2))
            tabs.push(list(ctrl.selectedPage()+3))
            return tabs
          }
          if ((ctrl.numberOfPages()-3)<ctrl.selectedPage()) {
            for (var i=6; i>=0; i--) {
              tabs.push(list(ctrl.numberOfPages()-i))
            } 
            return tabs
          }
        }else{
          tabs.push(list(ctrl.selectedPage()))
          return tabs
        }
      }(),
      m('a.f4.ba.bw1.ph3.pv2.tc.v-btm.dib.pointer.ml2.mb1', {
        onclick: function (e) {
          if (ctrl.selectedPage() != ctrl.numberOfPages()) {
            ctrl.nextPage();
          }
        }
      }, [
        m('span', {'aria-hidden': 'true'}, '>'),
      ]),
      function () {
        if (ctrl.numberOfPages() > 1) {
          return m('a.f4.ba.bw1.ph3.pv2.tc.v-btm.dib.pointer.ml2.mb1', {
            onclick: function (e) {
              if (ctrl.selectedPage() != ctrl.numberOfPages()) {
                ctrl.lastPage();
              }
            }
          }, [
            m('span', {'aria-hidden': 'true'}, '»'),
          ]);
        }
      }(),
      m('a.f4.bw1.ph3.pv2.tc.v-btm.dib.pointer.ml2.mb1.fr', [
        m('span.nowrap', {'aria-hidden': 'true'}, ctrl.selectedPage() + ' of ' + ctrl.numberOfPages()),
      ]),
    ]);
  } else {
    return m('div');
  }
};

module.exports = pagination;
